import { BlogSection } from "@/types/blog";

export const selbstfuersorge: BlogSection = {
  id: "selbstfuersorge",
  title: "Selbstfürsorge als Verantwortung",
  content: `
    <p>Erschöpfte Führungskräfte verlieren Empathie und Weitblick.</p>

    <p>Wer eigene Grenzen achtet, schützt nicht nur sich, sondern das gesamte System. Regeneration schafft bessere Entscheidungen.</p>

    <p>Selbstfürsorge ist damit kein persönlicher Luxus, sondern Teil professioneller Führung.</p>
  `
};
